export const Normalizers = {
  // Strings -------------------------------------------------------------------------------
  /**
   * Trims whitespace from a string value.
   * @param {*} value - The value to trim.
   * @returns {string|null} The trimmed string, or null if input is not a string.
   */
  trimString: value => (typeof value === 'string' ? value.trim() : null),

  // Numbers -------------------------------------------------------------------------------
  /**
   * Parses a value into a number.
   * @param {*} value - The value to parse.
   * @returns {number|null} The parsed number, or null if parsing fails.
   */
  parseNumber: value => {
    if (value == null) {
      return null;
    }

    const n = Number(value);

    return Number.isNaN(n) ? null : n;
  },
};
